import { RouteObject, useParams } from "react-router-dom";
import BillCanvasDesigner from "./components/designer/designer";
import BillTemplate from "../billTemplate/components/billTemplate/billTemplate";

export interface BillTemplateV2Route extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillTemplateV2Route[];
}

const BillCanvasDesignerWrapper = () => {
  const { id, templateId } = useParams<{ id: string; templateId: string }>();
  return <BillCanvasDesigner baseTemplateId={id} templateId={templateId} />;
};

export const billTemplateV2Routes: BillTemplateV2Route[] = [
  {
    path: "/bx/bill-setup/billtemplate",
    element: <BillTemplate />,
  },
  {
    path: "/bx/bill-setup/billtemplate/template-setup/:id/:templateId",
    element: <BillCanvasDesignerWrapper />,
  },
  {
    path: "/bx/bill-setup/billtemplate/template-setup",
    element: <BillCanvasDesigner />,
  },
];
